import { useEffect, useState } from 'react'

import { getRoomName } from 'helpers/room'
import { getActiveUsers } from 'services/apis/room'
import avatarStore from 'utils/avatarStore'

const useActiveParticipants = () => {
    const [participants, setParticipants] = useState([])

    useEffect(() => {
        ;(async () => {
            const roomName = getRoomName()
            const { data } = await getActiveUsers(roomName)
            const userIds = data.active_users.map(({ user }) => user)
            userIds.length && avatarStore.populate(userIds)
            setParticipants(data.active_users)
        })()
    }, [])

    return participants
}

export default useActiveParticipants
